import { Component, OnInit, EventEmitter, Output, Input, OnDestroy, AfterViewChecked, AfterViewInit } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { SearchTagCheckbox } from '../../model/search';
import { DamageAnalysis } from '../../model/damage.model';
import { ClassificationService } from '../../service/classification.service';
import { ThumbnailService } from '../../service/thumbnail.service';
import { SearchService } from '../../service/search.service';
import { RoiService } from '../../service/roi.service';
import { ParametersService } from '../../service/parameters.service';
import { VehicleDamagePipe } from '../../pipes/vehicle-damage.pipe';
import { DamageFilterService } from '../../damage-filter.service';

@Component({
  selector: 'app-damage-analysis-filter',
  templateUrl: './damage-analysis-filter.component.html',
  styleUrls: ['./damage-analysis-filter.component.less']
})
export class DamageAnalysisFilterComponent implements OnInit {
  damagesFilter: DamageAnalysis[];
  @Input() damages: DamageAnalysis[];
  @Output() updateFilters = new EventEmitter();
  filtersList: SearchTagCheckbox[]

  constructor(private readonly _classificationService: ClassificationService,
    private readonly _damageFilterService: DamageFilterService,
    private readonly _thumbnailService: ThumbnailService,
    private readonly _parametersService: ParametersService,
    private readonly _searchService: SearchService,
    readonly _roiService: RoiService,
    private readonly i18n: I18n,
  ) { }

  async ngOnInit() {
    if (this.damages && this.damages[0]) {
      if (this._classificationService.active) {
        console.log('init filter 1')
        let finderDataTag = await (await this._searchService.getFinderData()).admin.searchTagList.damageTag
        this.filtersList = await this._damageFilterService.setHideDamageList(this.damages, this.damages[0].tchekPtr.id, finderDataTag)
      } else
        this.filtersList = await this._damageFilterService.setHideDamageList(this.damages, this.damages[0].tchekPtr.id)
      this.hideDammageType()
    }
  }


  async hideDammageType() {
    if (this._thumbnailService.numberOfDamage === 0)
      return

    if (!this.damages || !this.damages[0])
      return

	  let finderData = await this._searchService.getFinderData()
    let finderDataTag =finderData.admin ? finderData.admin.searchTagList.damageTag : undefined
    if (this._classificationService.active)
      this.filtersList = await this._damageFilterService.setHideDamageList(this.damages, this.damages[0].tchekPtr.id, finderDataTag)
    else
      this.filtersList = await this._damageFilterService.setHideDamageList(this.damages, this.damages[0].tchekPtr.id)


    let hideAddedDamage = false
    if (this._classificationService.active) {
      let goodlist = [];
      this.filtersList.forEach(t => {
        this.damages.forEach(dam => {
          let index = goodlist.findIndex(c => (dam === c));
          if ((t.value === `${dam.type} ${dam.sev}` && t.checked === false
            && dam.classification !== true
            && dam.skipClassification !== true
            && dam.listRoi.length > 0)
            && index === -1
            && dam.isAuto === true)
            goodlist.push(dam)
        })
      })
      this.damagesFilter = goodlist;
    } else {
      let goodlist = [];
      this.filtersList.forEach(t => {
        if (t.value === 'added')
          hideAddedDamage = t.checked
      })
      this.filtersList.forEach(t => {
        this.damages.forEach(dam => {
          let index = goodlist.findIndex(c => (dam === c));
          if (((t.value === `${dam.type} ${dam.sev}` && t.checked === false && dam.isAuto === true)
            || (hideAddedDamage === false && dam.isAuto !== true))
            && index === -1) {
            goodlist.push(dam)
          }
        })
      })
      this.damagesFilter = goodlist;
    }
    this.updateFilters.emit(this.damagesFilter);
  }

}



// WEBPACK FOOTER //
// ./src/app/element/damage-analysis-filter/damage-analysis-filter.component.ts